module.exports = __webpack_public_path__ + "posture/static/img/middle.c886eb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/middle.png
// module id = Ty3t
// module chunks = 1